import { z } from 'zod/v4';

type ErrorFormat = 'tree' | 'pretty';

interface FormatOptions {
    format: ErrorFormat;
}

export function formatZodValidationError(err: unknown, options: FormatOptions): string {
    if (err instanceof z.ZodError) {
        switch (options.format) {
            case 'tree':
                return JSON.stringify(z.treeifyError(err), null, 2);
            case 'pretty':
                return z.prettifyError(err);
        }
    } else {
        return JSON.stringify(err, null, 2);
    }
}

export function parseRuntype<T extends z.ZodType>(schema: T, data: unknown): data is z.infer<T> {
    const result = schema.safeParse(data);
    return result.success;
}
